module.exports = __webpack_public_path__ + "img/product-discount-three.a5e9a7a.png";